import initDatePicker from 'src/components/datepicker';
import initFormHandler from 'src/components/form-handler';
import initLocationPicker from 'src/components/location-combobox';
import initTripTypePicker from 'src/components/trip-type-combobox';

initFormHandler();
initDatePicker();
initTripTypePicker();
initLocationPicker();
